<template>
    <div id="SubidorIncidencias_div" class="w-100 px-0 py-0">
        <div id="TituloGestionIncidencias_div">
            <h5 style="margin-bottom: 0px;">REPORTE PARA PRE-NÓMINA</h5>
            <h6 style="margin-top: 0px;">Genera reporte para pre-nómina del personal del Poder Judicial</h6>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
                <div class="area">
                    <div class="row">
                        <div class="form-group col-12" >
                            <label>Seleccione Mes del período</label>
                            <input type="month" id="fechaInicio" v-model="mesExportar" class="form-control" style="width: 100%" @change="cambiarMes($event)"/>
                        </div>
                    </div>
                    <div class="text-right">
                        <button class="btn btn-dark"  @click='Generar()'>Obtener Registros</button>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
                <div class="area" v-if="ListadoPrenomina.length>0">
                    <div class="row">
                        <div class="form-group col-6">
                            <h6>Periódo : {{ " " + FormatoLargo(this.fechaProps)}}</h6>
                            <h6>Listado del Personal, total : {{this.ListadoPrenomina.length}}</h6>
                        </div>
                        <div class="form-group col-6 text-right">
                            <label>Numero de Nómina:</label>
                            <input type="number" v-model="filtro" @change="capturaNomina($event)"/>
                        </div>
                    </div>
                    <div id="prenomina_table" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-custom">
                                <tr>
                                <th>Nómina</th>
                                <th>Servidor Público</th>
                                <th>Detalles en Control de Asistencias</th>
                                <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="text-dark" v-for="Lista in listaFiltrada" >
                                <td width="50">{{Lista.Persona.NumeroNomina}}</td >
                                <td width="300" v-html="DesglosaServidor(Lista.Persona)"></td>
                                <td width="400" v-html="DesgloseAsistencias(Lista)"></td> 
                                <td width="50" class="text-center">
                                    <i class="far fa-calendar-alt" @click='Calendario(Lista)' title ="Ver Calendario"></i>
                                </td>
                             </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import comun from '@/../static/js/comun'
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import router from '@/router/index'
import axios from 'axios'

export default {
    props: {
        ListadoRegistrosChecador:{
            type: Array,
            default: null
        },
        fechaRouter : "",
        paginaSeleccionada : {
            type: Number,
            default : 0
        }
    },
    data(){
        return {
            filtro: 0,
            fechaProps: "",
            fechaInicio: "",
            fechaFinal : "",
            mesExportar : moment().format('YYYY-MM'),
            Periodos:[
                {id: 1, value: "Primera Quincena"},
                {id: 2, value: "Segunda Quincena"}],
            ListadoPrenomina: [],
            listaFiltrada: []
            }
    },
    methods: {
        FormatoLargo(fecha){
            var fechaFormato = moment(fecha).locale('es-Es').format('MMMM YYYY').toUpperCase();
            return fechaFormato;
        },
        cambiarMes(){
             $("#catalogodePeriodos option[value='0']").prop("selected",true);
        },
        ValidarFechas(){
            if(moment(this.mesExportar).format()>moment().format())
            {
                comun.mensajeDeAlerta("No es posible obtener el reporte de un periódo superior al actual", null, null);
                 return false;
            }
            
            return true;
        },
        Generar(){
            // if(this.ValidarFechas()== true)
            // {
                this.fechaProps = this.mesExportar;
                var peticion = {
                    "FechaInicial" : this.mesExportar,
                }
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.SIAP.funcion.PreNomina, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                    ).then(respuesta => { 
                        if(respuesta.data.SiHayError){
                            this.mesExportar = moment().format('YYYY-MM');
                            $("#catalogodePeriodos option[value='0']").prop("selected",true);
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                  
                        } else { 
                            var datos = respuesta.data.ListadoPrenomina;
                           
                            this.ListadoPrenomina = this.formatoDatos(datos);
                            this.VerificarRetardos();
                            if(this.ListadoPrenomina.length>0)
                            {
                                this.listaFiltrada = this.ListadoPrenomina;
                                this.$nextTick(()=> { PaginarTabla('prenomina_table', 10)});
                            }
                            else
                            {
                                comun.mensajeDeAlerta("No existen registros para Pre-Nómina en periódo seleccionado", null, null);
                            }
                            this.mesExportar = moment().format('YYYY-MM');
                            $("#catalogodePeriodos option[value='0']").prop("selected",true);
                        }
                        comun.SeEstaCargandoInformacion(false);
                    }
                    ).catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);                
                    });
            //}
        },
        formatoDatos: function (lista){
            var ListaInicial = [];

            $.each(lista, function (index, registro)
            {
                var agrupar = ListaInicial.find(e=>e.Persona.PersonaId == registro.Persona.PersonaId);
                if(agrupar == undefined || agrupar == false)
                {
                    ListaInicial.push({
                        "Persona": registro.Persona,
                        "Checados" : [
                            {
                                "RegistroChecadorId" : registro.RegistroChecadorId,
                                "EntradaFechaRegistro" : registro.EntradaFechaRegistro,
                                "HoraEntrada": registro.HoraEntrada,
                                "SalidaFechaRegistro": registro.SalidaFechaRegistro,
                                "HoraSalida": registro.HoraSalida,
                                "TipoChecado": registro.TipoChecado,
                                "Intermedios" : registro.Intermedios
                            }
                        ]
                    })
                }
                else
                {
                    agrupar.Checados.push(
                        {
                            "RegistroChecadorId" : registro.RegistroChecadorId,
                            "EntradaFechaRegistro" : registro.EntradaFechaRegistro,
                            "HoraEntrada": registro.HoraEntrada,
                            "SalidaFechaRegistro": registro.SalidaFechaRegistro,
                            "HoraSalida": registro.HoraSalida,
                            "TipoChecado": registro.TipoChecado,
                            "Intermedios" : registro.Intermedios});
                }
            });
            return ListaInicial;
        },
        DesglosaServidor: function (datos){
            var Contenido ="";
            Contenido = Contenido + "Nombre : " + datos.NombreCompleto + "<br/>";
            Contenido = Contenido + "Puesto : " + datos.Puesto + "<br/>";
            Contenido = Contenido + "Área : " + datos.Seccion + "<br/>";
            return Contenido;
        },
        DesgloseAsistencias: function (datos){
            
            var contenido = ""
            var Inasistencias = datos.Checados.filter(e=>e.TipoChecado.TipoChecadoId==3);
            var Incompletos = datos.Checados.filter(e=>e.TipoChecado.TipoChecadoId==4 || e.TipoChecado.TipoChecadoId == 7 || e.TipoChecado.TipoChecadoId == 8);
            var retardo = datos.Checados.filter(e=>e.TipoChecado.TipoChecadoId==5 || e.TipoChecado.TipoChecadoId == 14);
            var salidaAnticipada = datos.Checados.filter(e=>e.TipoChecado.TipoChecadoId==6);
            var revisionChecados = datos.Checados.filter(e=>e.TipoChecado.TipoChecadoId==12);
            var faltaExcedido = datos.Checados.filter(e=>e.TipoChecado.TipoChecadoId==9);
            var jornadaIncompleta = datos.Checados.filter(e=>e.TipoChecado.TipoChecadoId==13);
            

            
            if(retardo.length>0)
            {
                contenido = contenido + "<b>Retardos : </b>" + retardo.length + "<br/>";
                $.each(retardo, function(id, dato)
                {
                    contenido = contenido + moment(dato.EntradaFechaRegistro).format('DD/MM/YYYY') + ", Hora de Entrada: " + dato.HoraEntrada + "<br/>";
                })
            }

            if(Inasistencias.length>0)
            {
                contenido = contenido + "<b>Faltas por Inasistencias : </b>" + Inasistencias.length + "<br/>";
                $.each(Inasistencias, function(id, dato)
                {
                    contenido = contenido + moment(dato.EntradaFechaRegistro).format('DD/MM/YYYY') + "<br/>";
                })
            };
            if(faltaExcedido.length>0)
            {
                contenido = contenido + "<b>Faltas por Checado en tiempo excedido : </b>" + faltaExcedido.length + "<br/>";
                $.each(faltaExcedido, function(id, dato)
                {
                    contenido = contenido + moment(dato.EntradaFechaRegistro).format('DD/MM/YYYY') + ", Hora de Entrada: " + dato.HoraEntrada + "<br/>";
                })
            };

            if(salidaAnticipada.length>0)
            {
                contenido = contenido + "<b>Salidas Anticipadas : </b>" + salidaAnticipada.length + "<br/>";
                $.each(salidaAnticipada, function(id, dato)
                {
                    contenido = contenido + moment(dato.EntradaFechaRegistro).format('DD/MM/YYYY') + ", Hora de Salida: " + dato.HoraSalida + "<br/>";
                })
            };

            if(jornadaIncompleta.length>0)
            {
                contenido = contenido + "<b>Jornadas Incompletas : </b>" + jornadaIncompleta.length + "<br/>";
                $.each(jornadaIncompleta, function(id, dato)
                {
                    contenido = contenido + "Fecha: " + moment(dato.EntradaFechaRegistro).format('DD/MM/YYYY') +", Entrada Oficial: " 
                                + dato.HoraEntrada + ", Salida Oficial : " + dato.HoraSalida +
                                ", Intermedios : " + dato.Intermedios + " Horas <br/>";
                })
            }
            if(Incompletos.length>0)
            {
                contenido = contenido + "<b>Checados Incompletos : </b>" + Incompletos.length + "<br/>";
                $.each(Incompletos, function(id, dato)
                {
                    contenido = contenido + (dato.HoraEntrada != null ? ("Entrada: " + moment(dato.EntradaFechaRegistro).format('DD/MM/YYYY') + " " + dato.HoraEntrada) : 
                    (dato.HoraSalida!=null ? ("Salida: " + moment(dato.SalidaFechaRegistro).format('DD/MM/YYYY') + " " + dato.HoraSalida) : "")) +  "<br/>";
                })
            }
            if(revisionChecados.length>0)
            {
                
                contenido = contenido + "<b>Revisión Checados Intermedios : </b>" + revisionChecados.length + "<br/>";
                $.each(revisionChecados, function(id, dato)
                {
                    var Diferencia = moment(dato.SalidaFechaRegistro).diff(moment(dato.EntradaFechaRegistro), 'days');
                    var Dia = Diferencia != 0 ? ("Entre los Dias : " +  moment(dato.EntradaFechaRegistro).format('DD/MM/YYYY') + " y " +moment(dato.SalidaFechaRegistro).format('DD/MM/YYYY'))
                    : ("Dia : " +  moment(dato.EntradaFechaRegistro).format('DD/MM/YYYY')) + ", Checados : " + dato.Intermedios;
                    contenido = contenido + Dia + "<br/>";
                });
            };
            return contenido;
        },
        Calendario(persona){
            var pagina = Math.trunc(this.ListadoPrenomina.indexOf(persona)/10);
            router.push({name: "calendarioChecador", params: {datos: persona.Persona, registros: this.ListadoPrenomina, FechaInicial: this.fechaProps, prenomina: true, paginaRetorno: pagina}});
        },
        VerificarRetardos(datos){
            //var Index = 0;
            let _this = this;
            var RemoveSelectedChecado = [];
            var RemovePersona = [];
            $.each(this.ListadoPrenomina, function (idPersona, datos)
            {
                //Index = this.ListadoPrenomina.indexOf(datos);
                $.each(datos.Checados, function(idChecado, dato)
                {  
                    if(dato.TipoChecado.TipoChecadoId == 5 || dato.TipoChecado.TipoChecadoId == 14)
                    {
                        //var posicion = datos.Checados.indexOf(dato);
                        RemoveSelectedChecado.push(idChecado);
                    }
                });
                
                if(RemoveSelectedChecado.length > 0 && RemoveSelectedChecado.length < 3 )
                {
                    for(var i = RemoveSelectedChecado.length -1; i>=0; i--)
                    {
                        _this.ListadoPrenomina[idPersona].Checados.splice(RemoveSelectedChecado[i], 1);
                    }
                }
                if(datos.Checados.length==0)
                {
                    RemovePersona.push(idPersona);
                }
                
                RemoveSelectedChecado = [];
                
            }) 
            if(RemovePersona.length>0)
            {
                for(var i = RemovePersona.length -1; i>=0; i--)
                    {
                        _this.ListadoPrenomina.splice(RemovePersona[i], 1);
                    }
            }
        },
        capturaNomina(){
            if(this.filtro>0 && this.filtro.length>=4)
            {
                this.listaFiltrada = this.ListadoPrenomina.filter(f=>f.Persona.NumeroNomina==this.filtro);
            }
            else
            {
                this.listaFiltrada = this.ListadoPrenomina;
                this.$nextTick(()=> { PaginarTabla('prenomina_table', 10)});
            }
        }
    },
    mounted() {
        if(this.ListadoRegistrosChecador!= null && this.ListadoRegistrosChecador.length>0)
        {
            this.fechaProps = this.fechaRouter;
            this.ListadoPrenomina  = this.ListadoRegistrosChecador;
            if(this.ListadoPrenomina.length>0)
            {
                var indice = this.ListadoPrenomina.findIndex(e=>e.Checados.length == 0);
                if(indice>=0)
                {
                    this.ListadoPrenomina.splice(indice,1);
                }
                this.listaFiltrada = this.ListadoPrenomina;
                this.$nextTick(()=> { PaginarTabla('prenomina_table', 10), IrPagina(this.paginaSeleccionada, 10, 'prenomina_table')});
            }
        }
    }
}   

</script>

<style scoped>
.thead-custom {
  background-color: #004746;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/SIAP/Checador/PreNomina.vue